var ContentTypes = (function () {
    function ContentTypes() {
    }
    ContentTypes.APPLICATION_JSON = "application/json";
    ContentTypes.TEXT_EVENT_STREAM = "text/event-stream";
    return ContentTypes;
}());
export default ContentTypes;
//# sourceMappingURL=ContentTypes.js.map